import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./fillable-form.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./fillable-form.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class FillableFormEffects {

  createFillableForms$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFillableForms),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FILLABLE_FORM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.store.dispatch(fromActions.upsertFillableForm({ fillableForm: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateFillableForm$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editFillableForms),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FILLABLE_FORM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableForm({ fillableForm: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteFillableForm$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeFillableForms),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_FILLABLE_FORM,
        variables: {
          formUid: action?.formUid,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteFillableForm({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllFillableForms$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getFillableForms),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_FILLABLE_FORM,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable forms'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFillableForms({ fillableForms: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  updateConfigurationFillableFormField$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateConfigurationFillableFormFields),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_FORM_CONFIGURATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableForm({ fillableForm: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  publishFillableFormField$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.publishFillableFormFields),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.PUBLISH_FILLABLE_FORM,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while publishing form'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableForm({ fillableForm: result?.data }));
              await this.notificationService.successMessage('Published Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });



  createFillableFormApiDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createFillableFormApiDetails),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_FILLABLE_FORM_API_DETAIL,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertFillableForm({ fillableForm: result?.data }));
              action.input.formApiUniqueId ?
                await this.notificationService.successMessage('Updated Successfully')
              :
                await this.notificationService.successMessage('Created Successfully')
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  // CITIIZEN FORMS

  citizenGetFillableForms$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetFillableForms),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_FILLABLE_FORMS,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching fillable forms'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadFillableForms({ fillableForms: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
